import React from 'react'
import { rhythm } from '../utils/typography'
import { FaXTwitter } from "react-icons/fa6";
import { FiMail, FiLinkedin } from "react-icons/fi";
import { Link } from 'gatsby'

export default ({ settings }) => (
  <div
  style={{
    textAlign: 'center'
  }}>
      <div
    style={{
      textAlign: 'left',
      display: 'flex',
      marginBottom: rhythm(0.5),
      marginTop: rhythm(3)
    }}
  >
    <img
      src={settings.author_avatar.imgix_url}
      alt={settings.author_name}
      style={{
        marginRight: rhythm(1 / 2),
        marginBottom: 0,
        width: rhythm(2),
        height: rhythm(2),
      }}
    />
    <div dangerouslySetInnerHTML={{ __html: settings.author_bio }} />
  </div> <Link
              style={{
                boxShadow: 'none',
                textDecoration: 'none',
                color: '#191919',
              }}
              to={'/contact'}
            ><FiMail  size='20px' style={{
              margin: '0 4px -3px 2px',
            }}/></Link>
    <a href="https://www.linkedin.com/in/kieran-jeffrey-smart-70a1a1a4" style={{
          color: '#191919',
          boxShadow: 'none',
        }}><FiLinkedin  size='20px' style={{
          margin: '0 4px -3px 2px',
        }}/></a>
    <a href="https://twitter.com/kieran_smart2" style={{
          color: '#191919',
          boxShadow: 'none',
        }}><FaXTwitter size='20px' style={{
          margin: '0 4px -3px 2px',
        }}/></a>
  </div>

)
